module.exports = __webpack_public_path__ + "00_2x.jpg?d8870391b1936000d086d1387003d48a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/00_2x.jpg
// module id = 77
// module chunks = 0